module.exports = __webpack_public_path__ + "download.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/download.png
 ** module id = 157
 ** module chunks = 0
 **/